import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
  buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import { shallowEqual, useSelector } from "react-redux";
import { getBacktestingConfigs, deleteBacktestingConfig, changeStatusBacktestingConfig, startBacktesting } from "../../../../api/backtestingConfig";
import { PlayArrow } from "@material-ui/icons";

export default function BacktestingConfigsPage() {
  const [data, setData] = useState([]);
  const [backtestingConfigId, setBacktestingConfigId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [backtestingConfigs, setBacktestingConfigs] = useState([]);

  const history = useHistory();
  const user = useSelector((store) => store.authentication?.user, shallowEqual);

  function buttonFormatter(cell) {
    const elem = data.find((item) => item._id === cell);
    return (
      <>
        <Tooltip title="Edit">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => history.push("/edit-backtesting-config/" + cell)}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {user?.role === "admin" && !elem?.isMain && (
          <>
            <Tooltip title={elem?.active ? "Disable" : "Enable"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setBacktestingConfigId(elem);
                  setOpenConfirmDialog(1);
                }}
              >
                {elem?.active ? (
                  <ToggleOffIcon />
                ) : (
                  <ToggleOnIcon style={{ color: "red" }} />
                )}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setBacktestingConfigId(elem);
                  setOpenConfirmDialog(2);
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
            
            <Tooltip title={"Start execution"}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setBacktestingConfigId(elem);
                  setOpenConfirmDialog(3);
                }}
              >
                <PlayArrow />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    );
  }

  const columns = [
    { dataField: "fullName", text: "Full name" },
    { dataField: "_id", text: "", formatter: buttonFormatter },
  ];

  useEffect(() => {
    getBacktestingConfigs()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
          setBacktestingConfigs(res.data);
          setRefresh(false);
        }
      })
      .catch((error) => {
        if (error?.request?.status !== 404) 
          alertError({ error, customMessage: "Could not get backtestingConfigs." });
      });
  }, [refresh]);

  function getData(configs) {

    function sortByMain(a) {
      if (a.isMain) return -1;
      return 1;
    }

    let data = [...configs];

    // for (let i = 0; i < configs?.length; ++i) {
    //   data.push(configs[i]);
    // }
    data.sort(sortByMain)

    return data;
  } 

  return (
    <>
      <Card>
        <CardHeader title="Backtesting configs list">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => history.push("/edit-backtesting-config")}
            >
              Add new
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>

          <Table data={getData(backtestingConfigs)} columns={columns} />

          <ConfirmDialog
            title={`Are you sure you want to ${
              backtestingConfigId?.active ? "disable" : "enable"
            } this backtestingConfig?`}
            open={openConfirmDialog === 1}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              changeStatusBacktestingConfig(backtestingConfigId._id, !backtestingConfigId?.active)
                .then((res) => {
                  if (res.status === 200) {
                    alertSuccess({
                      title: `${backtestingConfigId?.active ? "Disabled!" : "Enabled!"}`,
                      customMessage: `backtestingConfig ${
                        backtestingConfigId?.active ? "disabled" : "enabled"
                      } successfully`,
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: `Could not ${
                      backtestingConfigId?.active ? "disable" : "enable"
                    } backtestingConfig.`,
                  });
                });
            }}
          />
          <ConfirmDialog
            title={"Are you sure you want to remove this backtestingConfig?"}
            open={openConfirmDialog === 2}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteBacktestingConfig(backtestingConfigId._id)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Deleted!",
                      customMessage: "backtestingConfig removed successfully.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not remove backtestingConfig.",
                  });
                });
            }}
          />

          <ConfirmDialog
            title={"Do you want to start the test?"}
            open={openConfirmDialog === 3}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              startBacktesting(backtestingConfigId._id)
                .then((res) => {
                  if (res.status === 204 || res.status === 200) {
                    alertSuccess({
                      title: "Started!",
                      customMessage: "You can see the results on the page Back testing results.",
                    });
                    setRefresh(true);
                  }
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "Could not start test.",
                  });
                });
            }}
          />
        </CardBody>
      </Card>
    </>
  );
}
